import { useState } from 'react'
import classNames from 'classnames'

import Image from '../ui/Image/Image'
import { AccordionItem } from '../Accordion/Accordion'
import BulletList from '../BulletList/BulletList'
import { getImageUrl } from '../../utils'
import styles from './UpiLayout.module.scss'

function UPIBenefits({ benefits = [] }) {
  const [selectedBenefit, setSelectedBenefit] = useState(benefits[0])

  const handleBenefitClick = (benefit) => {
    setSelectedBenefit({ ...benefit })
  }
  const [activeIndex, setActiveIndex] = useState(0)

  const handleClick = (index) => {
    setActiveIndex(activeIndex === index ? null : index)
  }

  return (
    <>
      <div className={styles.benefitsContainer}>
        <div className={styles.leftContainer}>
          <div className={styles.leftImageContainer}>
            <Image
              src={getImageUrl(selectedBenefit?.image)}
              alt={selectedBenefit?.image?.alternativeText}
            />
          </div>
          <div className={styles.titleContainer}>
            {benefits.map((benefit) => (
              <span
                key={'benefits' + benefit?.id}
                className={classNames(styles.benefitsTitle, {
                  [styles['fade-in']]: benefit?.id === selectedBenefit?.id,
                })}
                onClick={() => handleBenefitClick(benefit)}
              >
                {benefit.title}
              </span>
            ))}
          </div>
        </div>
        <BulletList
          bulletList={selectedBenefit?.bulletssubsection}
          className={styles.bulletContainer}
        />
      </div>
      <div className={styles.accordionBulltets}>
        {benefits.map((benefit, index) => (
          <AccordionItem
            image={benefit?.image}
            question={benefit.title}
            key={'bulletList' + benefit?.id}
            isOpen={activeIndex === index}
            onClick={() => handleClick(index)}
            titleClass={styles.accordionTitle}
          >
            <BulletList
              bulletList={benefits[index]?.bulletssubsection}
              className={styles.bulletContainer}
            />
          </AccordionItem>
        ))}
      </div>
    </>
  )
}

export default UPIBenefits
